import * as math from 'mathjs';
import store from '@/store'

const commonUseData = [
  '当前日期', '昨天日期', '明天日期', '当前年份', '下周时间段', '当前星期', '当前个数', '当前上午/下午', '当前月份', '学年',
  '学期', '上下学期'
]
export const dealText = ({ text, commonData, customData, functionParms, stepList, setData, asyncCount }) => {
  
  // text 文本
  // commonData 经常使用的变量
  // customData 自定义的变量
  // functionParms 函数变量
  // stepList ai步骤列表及数据
  // setData 标题设置内容 以表单的title为key
  let customList = []
  text.split('${').forEach(e => {
    if (e.search('}') !== -1) {
      const breakWord = e.split('}')
      if (breakWord[0]) {
        customList.push(breakWord[0])
      }
    }
  })
  if (customList.length > 0) {
    let tableObj = [] // ai数据表格表头字段
    let isDetailData = false // 是否存在明细控件的数据
    for (const item of customList) {
      const fieldArr = item.split('_')
      const name = fieldArr[0]
      const dataType = fieldArr[1]
      const userKey = fieldArr[2] // 存在这个就是联系人
      // 常用的字段
      if (commonUseData.includes(item) && commonData[item] !== undefined) {
        text = text.replaceAll('${'+ item +'}', commonData[item])
      } else if (item.search('当前用户') !== -1 && dataType !== 'custom' && dataType !== 'customRule') {
        text = text.replaceAll('${'+ item +'}', commonData[dataType])
      } else if (item.search('可同步条数') !== -1 && dataType !== 'custom' && dataType !== 'customRule') {
        text = text.replaceAll('${'+ item +'}', asyncCount)
      } else {
        // 自定义变量的设置
        if (dataType === 'custom') {
          // console.log('自定义变量', item)
          const index = customData.findIndex(iter => iter.name === name)
          if (index !== -1) {
            const itemData = customData[index]
            if (itemData.type === 'relation-user') {
              // 当联系人有数据
              if (itemData.value.length > 0) {
                const user = itemData.value[0]
                let val = user[userKey]
                if (userKey === 'typeLable') {
                  const userTip = store.state.userTipList.find(item => { return user.type === item.keytype })
                  val = userTip.name
                }
                text = text.replaceAll('${'+ item +'}', val)
              }
            } else if (itemData.type === 'organization' || itemData.type === 'roule') {
              // 组织角色
              if (itemData.value.length > 0) {
                const val = itemData.value.map(item => { return item.name })
                text = text.replaceAll('${'+ item +'}', val.join())
              }
            } else if (itemData.type === 'image') {
              const val = Array.isArray(itemData.value) ? itemData.value.map(item => { return item.content || '' }) : []
              text = text.replaceAll('${'+ item +'}', val.join())
            } else {
              if (itemData.value !== undefined) {
                // 判断匹配的值是否是数组，并且包含response字段，如果包含则匹配的文件解析传参
                if (Array.isArray(itemData.value) && itemData.value.some(item => 'response' in item)) {
                  const localValue = localStorage.getItem('fileAnalysisStorage');
                  if (localValue !== null) {
                    text = text.replaceAll('${'+ item +'}', localValue)
                  }
                  else {
                    text = text.replaceAll('${'+ item +'}', '')
                  }
                } else {
                  text = text.replaceAll('${'+ item +'}', itemData.value)
                }
              }
            }
          }
        } else if (dataType === 'customRule' && functionParms) {
          // 函数计算
          const index = functionParms.findIndex(iter => iter.name === name)
          if (index !== -1) {
            const resultVal = setFunctionParms(functionParms[index], customData, commonData)
            text = text.replaceAll('${'+ item +'}', resultVal)
          }
        } else if ((dataType === 'dataForm' || dataType === 'dataTable') && stepList) {
          // 表单数据
          // const appInfo = name.split('.')
          // const appName = appInfo[0] // 应用名称
          // const fieldName = appInfo[1] // 字段名称
          // const detailData = appInfo[2] ?  appInfo[2] : '' // 详情数据;
          for(let i = 0; i < stepList.length-1; i++){
            const stepItem = stepList[i]
            const appArr = stepItem?.dataInfo?.appArr
            if (!Array.isArray(appArr) || !stepItem?.formdata) continue
            
            for(let j = 0; j < appArr.length; j++){
              // 匹配到对应的表单名称后，把该表单的formdata传值替换到文本中
              if(appArr[j].name === name){
                let val = stepItem.formdata[appArr[j].title + '_' + appArr[j].type]
                if (typeof val === 'undefined' || val === ''){
                  val = ''
                  text = text.replaceAll('${'+ item +'}', val)
                }
                else{
                  switch (appArr[j].type) {
                    case 'checkbox': //多选框
                      try {
                        var array = typeof val === 'string' ? JSON.parse(val) : val;
                      } catch (e) {
                        array = val.split(',');
                      }
                      val = Array.isArray(array) ? array.join(",") : val;
                      break;
                    case 'relation-user': //联系人控件
                      try {
                        // var array = typeof val === 'string' ? JSON.parse(val) : val;
                      } catch (e) {
                        array = val.split(',');
                      }
                      val = Array.isArray(array) ? array.map(function(item) {
                        return item.realname || item;
                      }).join(",") : val;
                      break;
                    case 'organization': //组织控件
                      try {
                        // var array = typeof val === 'string' ? JSON.parse(val) : val;
                      } catch (e) {
                        array = val.split(',');
                      }
                      val = Array.isArray(array) ? array.map(function(item) {
                        return item.name || item;
                      }).join(",") : val;
                      break;
                    case 'roule': //角色控件
                      try {
                        // var array = typeof val === 'string' ? JSON.parse(val) : val;
                      } catch (e) {
                        array = val.split(',');
                      }
                      val = Array.isArray(array) ? array.map(function(item) {
                        return item.name || item;
                      }).join(",") : val;
                      break;
                    case 'location': //定位控件
                      try {
                        // var array = typeof val === 'string' ? JSON.parse(val) : val;
                      } catch (e) {
                        array = val.split(',');
                      }
                      val = Array.isArray(array) ? array.map(function(item) {
                        return item.addressName || item;
                      }).join(",") : val;
                      break;
                    case 'file': //附件
                      if (val && val.length > 0) {
                        let fileContent = '';
                        for (let i = 0; i < val.length; i++) {
                          // 检查是否存在 val[i].text
                          if (val[i].text) {
                            fileContent += val[i].text;
                          }
                        }
                        // 将拼接后的内容赋值给 val
                        val = fileContent;
                      } else {
                        val = '';
                      }
                      break;
                    default:
                      break;
                  }
                  text = text.replaceAll('${'+ item +'}', val)
                }
              }
            }
          }
        } else if (dataType === 'addTable' && stepList) {
          for(let i = 0; i < stepList.length-1; i++){
            for(let j = 0; j < stepList[i].dataInfo.appArr.length; j++){
              // 匹配到对应的表单名称后，把该表单的formdata传值替换到文本中
              if(stepList[i].dataInfo.appArr[j].name === name){                
                tableObj.push({
                  name: stepList[i].dataInfo.appArr[j].name,
                  title: stepList[i].dataInfo.appArr[j].title
                })
              }
            }
          }
        } else if (dataType === 'addDetailsTable' && stepList) {
          // 获取明细控件的数据
          for(let i = 0; i < stepList.length-1; i++){
            for(let j = 0; j < stepList[i].dataInfo.appArr.length; j++){
              // 匹配到对应的表单名称后，把该表单的formdata传值替换到文本中
              console.log("stepList[i].dataInfo.appArr[j]===",stepList[i].dataInfo.appArr[j].name,name);
              if(stepList[i].dataInfo.appArr[j].name === name){                
                tableObj.push({
                  name: stepList[i].dataInfo.appArr[j].name,
                  title: stepList[i].dataInfo.appArr[j].title
                })
                isDetailData = true
              }
            }
          }
        } else if (dataType === 'titleSet' && setData) {
          const [_title, _type] = name.split('.')
          const value = setData[`${_title}_${_type}`]
          if (value !== undefined) {
            text = text.replaceAll('${'+ item +'}', value)
          } else {
            text = text.replaceAll('${'+ item +'}', '')
          }
        } else {
          text = text.replaceAll('${'+ item +'}', '')
        }
      }
    }
    console.log("tableObj==",tableObj);
    // ai模式如果有插入表格，需要进行数据填充
    if(tableObj.length > 0){
      // text的table默认只有tr th标签，需要加上tr td标签
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const tbody = doc.querySelector('tbody');
      const originalTr = tbody.querySelector('tr');
      const variableRegex = /\${[^}]+\.([^_]+)_[^}]*}/;

      // 克隆原始行
      const newTr = originalTr.cloneNode(true);

      // 将克隆行的 th 全部替换为 td
      Array.from(newTr.querySelectorAll('th')).forEach(th => {
        const td = document.createElement('td');
        // 复制所有属性
        Array.from(th.attributes).forEach(attr => {
          td.setAttribute(attr.name, attr.value);
        });
        // 保留原始变量字符串（不进行过滤）
        td.innerHTML = th.innerHTML;
        th.parentNode.replaceChild(td, th);
      });

      Array.from(originalTr.querySelectorAll('th')).forEach(th => {
        const originalText = th.innerHTML;
        th.innerHTML = originalText.replace(variableRegex, (match, p1) => p1);
      });

      // 将新行添加到表格
      tbody.appendChild(newTr);
      // 获取最终 HTML
      const serializer = new XMLSerializer();
      const finalHtml = serializer.serializeToString(doc.querySelector('table'));
      console.log("finalHtml=====",finalHtml);
      const updatedHtml = updateTable(finalHtml, tableObj, stepList, isDetailData);
      // 将更新后的表格 HTML 替换回原始文本
      const updatedText = text.replace(/<table[\s\S]*?<\/table>/, updatedHtml);
      // 返回更新后的文本
      return updatedText;
    }
  }
  return text
}

// 计算时间差
export const calculateDaysDiff = (targetDateStr) => {
  if (!targetDateStr) return null;
  const dateStr = targetDateStr.split(' ')[0];
  const targetDate = new Date(dateStr);
  const currentDate = new Date();
  // 清除时间部分，只比较日期
  const targetDateOnly = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
  const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  const diffTime = targetDateOnly.getTime() - currentDateOnly.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  // 如果小于0，返回0
  return diffDays < 0 ? 0 : diffDays;
}

export const setFunctionParms = (config, customData, commonData = {}) => {
  let conditionStr = config.condition;
  // 使用正则表达式匹配大写字母和括号内的内容
  let strFilter = conditionStr.match(/([A-Z]+)\(([^)]+)\)/);
  // 计算结果
  if (strFilter && strFilter.length >= 3) {
    let mathFun = strFilter[1];
    let nameVal = strFilter[2];
    let val = dragResule(nameVal, customData, commonData)
    let resultVal = mathFunRun(val, mathFun)
    // console.log("函数公式计算结果=",resultVal);
    return resultVal
  }
}

// 函数公式计算 formula:函数计算公式  formdata：所有字段的值
const dragResule = (formula, customData, commonData = {}) =>{
  // 遍历数组并构建表达式
  let expression = formula.replace(/<[^>]+>/g, function(match) {
    let valName = match.replace(/<|>/g, '');
    let index = customData.findIndex(iter => iter.name === valName)
    if (index !== -1) {
      if (customData[index].type === 'relation-user') {
        // 当联系人有数据
        if (customData[index].value.length > 0) {
          const user = customData[index].value[0]
          return user['realname']
        }
       } else if (customData[index].type === 'organization' || customData[index].type === 'roule') {
          // 组织角色
          if (customData[index].value.length > 0) {
            console.log(customData[index].value, 'customData[index].value')
            const val = customData[index].value.map(item => { return item.name })
            return val.join()
          }
        } else {
        if (customData[index].value !== undefined) {
          return customData[index].value
        }
      }
    } else if (valName === '当前用户') {
      return commonData['realname']
    } else if (commonData[valName]) {
      return commonData[valName]
    }
  });
  // console.log("函数公式==",expression)
  return `${expression}`;
}

const updateTable = (tableHtml, tableData, stepList, isDetailData) => {
  try {
    // 解析HTML字符串为DOM元素
    const parser = new DOMParser();
    const doc = parser.parseFromString(tableHtml, 'text/html');
    const tables = doc.querySelectorAll('table');  
    let rowsData = [] // ai数据表格数据    
    if(isDetailData){
      // 获取表格和明细控件数据
      for(let i = 0; i < stepList.length-1; i++){
        if(stepList[i].allFormdata){
          rowsData = rowsData.concat(stepList[i].allFormdata);
        }
        if(stepList[i].formdata){
          // 处理明细控件数据
          Object.keys(stepList[i].formdata).forEach(key => {
            if(key.includes('details')) {
              try {
                // 解析JSON字符串为数组对象
                const detailsData = JSON.parse(stepList[i].formdata[key]);
                // 移除最后一个元素(字段名数组)
                if(Array.isArray(detailsData) && detailsData.length > 0) {
                  // const fields = detailsData.pop();
                  // 处理每个对象的键名，删除下划线及其后面的字符串
                  const processedData = detailsData.map(item => {
                    const newItem = {};
                    Object.keys(item).forEach(field => {
                      const newKey = field.split('_')[0]; // 获取下划线前的部分
                      newItem[newKey] = item[field];
                    });
                    return newItem;
                  });
                  rowsData = rowsData.concat(processedData);
                }
              } catch(e) {
                console.error('解析明细数据失败:', e);
              }
            }
          });
        }
      }
    }
    else{
      // 获取表格数据
      for(let i = 0; i < stepList.length-1; i++){
        if(stepList[i].allFormdata){
          rowsData = rowsData.concat(stepList[i].allFormdata);
        }
      }
    }
    console.log("rowsData==",rowsData);

    tables.forEach((table) => {
      const tbody = table.querySelector('tbody');
      if (!tbody) return;

      // 查找包含 ${xxx_addTable} 或 ${xxx_addDetailsTable} 的单元格并记录其位置
      const templateRow = Array.from(tbody.querySelectorAll('tr')).find(row => {
        return Array.from(row.querySelectorAll('td')).some(cell => 
          cell.textContent.includes('_addTable') || cell.textContent.includes('_addDetailsTable')
        );
      });

      if (!templateRow) return;

      // 获取模板行的结构和字段映射
      const templateCells = templateRow.querySelectorAll('td');
      const fieldMappings = Array.from(templateCells).map(cell => {
        const match = cell.textContent.match(/\$\{([^_]+)_addTable\}/) || cell.textContent.match(/\$\{([^_]+)_addDetailsTable\}/);
        return match ? match[1] : null;
      }).filter(Boolean);
      console.log("templateCells==",templateCells);
      console.log("fieldMappings==",fieldMappings);

      // 如果找到了模板行和字段映射
      if (fieldMappings.length > 0) {
        // 克隆模板行作为新行的基础
        const newRows = rowsData.map(rowData => {
          // console.log("rowData222==",rowData);
          const newRow = templateRow.cloneNode(true);
          const cells = newRow.querySelectorAll('td');
          
          cells.forEach(cell => {
            const placeholder = cell.textContent.match(/\$\{([^_]+)_addTable\}/) || cell.textContent.match(/\$\{([^_]+)_addDetailsTable\}/);
            if (placeholder) {
              const fieldName = placeholder[1];
              const tableDataItem = tableData.find(item => item.name === fieldName);
              // console.log("tableDataItem==",tableDataItem);
              if (tableDataItem) {
                let val = rowData[tableDataItem.title] || rowData[fieldName.includes('.') ? fieldName.split('.')[1] : fieldName];
                console.log("val==",val)
                
                // 处理可能是JSON字符串的情况
                if (typeof val === 'string' && val.startsWith('[') && val.endsWith(']')) {
                  try {
                    val = JSON.parse(val);
                  } catch (e) {
                    console.error('Failed to parse JSON string:', e);
                  }
                }

                // 处理数组类型的值
                if (Array.isArray(val)) {
                  if (val.length > 0) {
                    if (val[0].realname) {
                      val = val.map(item => item.realname).join(",");
                    } else if (val[0].name) {
                      val = val.map(item => item.name).join(",");
                    } else if (val[0].orgname) {
                      val = val.map(item => item.orgname).join(",");
                    }
                  } else {
                    val = '';
                  }
                }
                // 检查val是否包含HTML标签
                if (typeof val === 'string' && /<[a-z][\s\S]*>/i.test(val)) {
                  // 如果包含HTML标签，使用innerHTML
                  cell.innerHTML = val || '';
                } else {
                  // 如果是普通文本，使用textContent
                  cell.textContent = val || '';
                }
                console.log("cell content==", val);
              }
            }
          });
          
          return newRow;
        });

        // 移除模板行并添加新行
        templateRow.remove();
        newRows.forEach(row => tbody.appendChild(row));
      }
    });

    return doc.body.innerHTML;
  } catch (error) {
    console.error('Error updating table:', error);
    return tableHtml; // 发生错误时返回原始HTML
  }
};
// 函数计算-所有函数列表
const mathFunRun = (val, mathFun) => {
  // 多个文本合并，使用数组进行拼接
  let countArr = val.split(",")
  let concatenatedString = ''
  let resultVal = ''
  let undefinedLen = 0
  for(let i = 0; i < countArr.length; i++){
    if(countArr[i] != 'undefined'){
      concatenatedString += countArr[i]
    }
    else undefinedLen++
  }
  if(undefinedLen == countArr.length){
    return resultVal = undefined
  }
  switch (mathFun) {
    case "IF":
      // IF三元运算
      resultVal = evaluateCondition(countArr)
      break;
    case "SUM":
      // 求和
      resultVal = math.evaluate('sum('+val+')')
      break;
    case "MAX":
      // 最大数
      resultVal = math.evaluate('max('+val+')')
      break;
    case "MIN":
      // 最小数
      resultVal = math.evaluate('min('+val+')')
      break;
    case "MOD":
      // 两数相除的余数
      resultVal = math.evaluate('mod('+val+')')
      break;
    case "AVG":
      // 平均值
      resultVal = math.evaluate('mean('+val+')')
      resultVal = resultVal.toFixed(2)
      break;
    case "ABS":
      // 绝对值
      resultVal = math.evaluate('abs('+val+')')
      break;
    case "CONCAT":
      // 多个文本合并
      resultVal = math.concat(concatenatedString)
      break;
    default:
      break;
  }
  return resultVal;
}
// 函数运算if三元运算
const evaluateCondition = (arr) => {
  const condition = arr[0];
  const trueValue = arr[1].replace(/"/g, '');
  const falseValue = arr[2].replace(/"/g, '');
  let result;
  if (condition.includes('>') && !condition.includes('>=')) { //大于
    const operands = condition.split('>');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand > rightOperand ? trueValue : falseValue;
  } else if (condition.includes('>=')) { //大于等于
    const operands = condition.split('>=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand >= rightOperand ? trueValue : falseValue;
  } else if (condition.includes('<') && !condition.includes('<=')) { //小于
    const operands = condition.split('<');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand < rightOperand ? trueValue : falseValue;
  } else if (condition.includes('<=')) { //小于等于
    const operands = condition.split('<=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand <= rightOperand ? trueValue : falseValue;
  } else if (condition.includes('!=')) { //不等于
    const operands = condition.split('!=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand != rightOperand ? trueValue : falseValue;
  } else if (condition.includes('=')) { //等于
    const operands = condition.split('=');
    const leftOperand = typeof operands[0] === 'number' ? parseFloat(operands[0]) : operands[0];
    const rightOperand = typeof operands[1] === 'number' ? parseFloat(operands[1]) : operands[1];
    if((typeof leftOperand === 'number' && isNaN(leftOperand)) || (typeof rightOperand === 'number' && isNaN(rightOperand))) result = '';
    else result = leftOperand == rightOperand ? trueValue : falseValue;
  } else {
    // 未知条件
    console.log("所有IF条件都不匹配，请重试");
  }
  return result;
}

